import React, { Fragment } from 'react';
import { Button, Header, Loader, Table, Form } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { DateTimePicker } from 'react-widgets';
import { Redirect } from 'react-router-dom';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class AllStudents extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],

            dateOfAbandonment: new Date(),
            droppedOutReason: null,

            droppedOutReasonOptions: [],

            loading: true,
            confirmation: false,
            yes: false,
            load: false,
            deleteConfirmation: false

        };
        this.withdrawalStudent = this.withdrawalStudent.bind(this);
        this.getStudents = this.getStudents.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.deleteStudentStudyProgram = this.deleteStudentStudyProgram.bind(this);
        this.getDroppedOutReasonOptions = this.getDroppedOutReasonOptions.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        this.getStudents();
        this.getDroppedOutReasonOptions();
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value || null
        });
    }
    getDroppedOutReasonOptions() {
        axios.get('/dropout-reasons')
            .then(res => {
                const droppedOutReasonOptions = res.data.map(el => ({
                    value: el.id,
                    key: el.id,
                    text: el.name
                }));
                this.setState({ droppedOutReasonOptions });
            })
            .catch(err => {
                console.log('Failed to fetch poll orgUnitsOptions.');
            });
    }

    getStudents() {
        let docFilter = {
            jmbg: this.props.jmbg,
            studyProgramId: this.props.student.studyProgramId
        };

        axios.post((localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator')
            ? `students/filter-students-by-jmbg/${localStorage.getItem('orgUnit')}`
            : 'students/filter-students-by-jmbg/', { ...docFilter })
            .then(res => {
                this.setState({ data: res.data });
            })
            .catch(err => {
                console.log('Failed to fetch filter results');
            });
    }


    withdrawalStudent(studentId, studyProgramId) {
        if (!this.state.droppedOutReason) {
            if (!this.state.droppedOutReason) { toast('Niste odabrali razlog!'); this.setState({ droppedOutReasonErr: true }); } else { this.setState({ droppedOutReasonErr: false }); }
        } else {
            let obj = {
                studentId, studyProgramId, droppedOutDate: this.state.dateOfAbandonment, dropoutReasonId: this.state.droppedOutReason
            };
            this.setState({ loader: true });
            axios.put('students/study-program-withdrawal', { ...obj })
                .then(res => {
                    toast('Student/ica je uspješno ispisan/a sa smjera (studijskog programa).');
                    this.getStudents();
                    this.props.updateStudentStatuses();
                    this.props.setActiveIndex(0);
                    // this.props.toggleAbandonmentVisibility();
                    this.props.getCurrentStudyProgramInfo();
                    this.setState({ confirmation: false, load: true, loader: false });
                })
                .catch(err => {
                    toast('Došlo je do greške! Student/ica nije ispisan/a sa smjera (studijskog programa).');
                    this.setState({ confirmation: false, loader: false });
                });
        }
    }

    handleDateChange(name, date) {
        this.setState({
            [name]: date
        });
    }

    deleteStudentStudyProgram() {
        const { studentStudyProgramId } = this.props;
        axios.delete(`students/delete-student-study-program/${studentStudyProgramId}`)
            .then(res => {
                this.setState({ redirectOnFilterStudent: true });
            })
            .catch(err => {
                if (err.response.data === 'This ssp is enrolled in courses and thus cannot be deleted!') {
                    toast('Nije moguće izbrisati studenta. Student je upisan u predmete.');
                } else if (err.response.data === 'This ssp is enrolled in semesters and thus cannot be deleted!') {
                    toast('Nije moguće izbrisati studenta. Student je upisan u semestar.');
                } else if (err.response.data === 'This ssp has document requests and thus cannot be deleted!') {
                    toast('Nije moguće izbrisati studenta. Student ima zahtjeve za dokumente.');
                } else if (err.response.data === 'This ssp has equivalence data and thus cannot be deleted!') {
                    toast('Nije moguće izbrisati studenta. Student ima podatke o ekvivalenciji.');
                } else if (err.response.data === 'This ssp has recognized exams and thus cannot be deleted!') {
                    toast('Nije moguće izbrisati studenta. Student ima podatke o priznavanju.');
                } else if (err.response.data === 'This ssp has mobility data and thus cannot be deleted!') {
                    toast('Nije moguće izbrisati studenta. Student ima podataka o mobilnosti.');
                } else if (err.response.data === 'This ssp has student pauses and thus cannot be deleted!') {
                    toast('Nije moguće izbrisati studenta. Student ima podatke o statusu mirovanja.');
                } else if (err.response.data === 'This ssp has disciplinary procedures and thus cannot be deleted!') {
                    toast('Nije moguće izbrisati studenta. Student ima podatke o disciplinskim mjerama..');
                } else if (err.response.data === 'This ssp has thesis data and thus cannot be deleted!') {
                    toast('Nije moguće izbrisati studenta. Student ima podatke o temi.');
                } else if (err.response.data === 'User role is created for this ssp and ssp cannot be deleted because of that!') {
                    toast('Nije moguće izbrisati studenta. Student ima pristupne podatke.');
                } else {
                    toast('Došlo je do greške. Student nije izbrisan.');
                }
            });
    }

    render() {
        // eslint-disable-next-line react/jsx-no-undef
        if (this.state.redirectOnFilterStudent) return <Redirect push to={{ pathname: '/filtriranje-studenata' }} />;
        return (
            <div>
                {
                    this.state.deleteConfirmation ? <Header as="h6" textAlign="center" floated="right">
                        <h4>Jeste li sigurni?</h4>
                        <h6><i>Brisanje svih veze sa studijskim programom.</i></h6>
                        <Button.Group>
                            <Button
                                basic="true"
                                color="blue"
                                onClick={this.deleteStudentStudyProgram}
                            > DA</Button>
                            <Button
                                basic="true"
                                color="red"
                                onClick={() => { this.setState({ deleteConfirmation: false }); }}
                            >  NE

                            </Button>
                        </Button.Group>

                    </Header> : localStorage.getItem('activeRole') !== 'Administrator' ? null : <Button
                        floated="right"
                        disabled={localStorage.getItem('activeRole') !== 'Administrator'}
                        color="red"
                        onClick={() => { this.setState({ deleteConfirmation: true }); }}
                    >
                        Brisanje studenta</Button>
                }
                <br />

                {this.state.loader ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader size="medium" active inline="centered" /></div>
                    : this.state.data.length ?
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field required error={this.state.droppedOutReasonErr}>
                                    <label>Razlog ispisa</label>
                                    <Form.Dropdown
                                        clearable
                                        placeholder="Odaberite razlog ispisa"
                                        value={this.state.droppedOutReason}
                                        onChange={this.handleInputChange}
                                        name="droppedOutReason"
                                        options={this.state.droppedOutReasonOptions}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field><Form.Field>
                                    <label>Datum ispisa</label>
                                    <DateTimePicker
                                        format="D. M. YYYY."
                                        defaultValue={new Date()}
                                        time={false}
                                        onChange={this.handleDateChange.bind(null, 'dateOfAbandonment')}
                                        value={this.state.dateOfAbandonment}
                                    />
                                </Form.Field>
                            </Form.Group>


                            {
                                this.state.confirmation ? <Header as="h6" textAlign="center" floated="right">
                                    <h4>Jeste li sigurni?</h4>
                                    <h6><i>Ispis studenta.</i></h6>
                                    <Button.Group>
                                        <Button
                                            basic="true"
                                            color="blue"
                                            onClick={() => this.withdrawalStudent(this.state.data[0].studentId, this.state.data[0].studyProgramId)}
                                        > DA</Button>
                                        <Button
                                            basic="true"
                                            color="red"
                                            onClick={() => { this.setState({ confirmation: false }); }}
                                        >  NE

                                        </Button>
                                    </Button.Group>

                                </Header> :
                                <Button
                                        floated="right"
                                        compact
                                        basic="true"
                                        color="red"
                                        // size="small"
                                        onClick={() => this.setState({ confirmation: true })}
                                    >
                                        Ispiši studenta
                                    </Button>}

                        </Form>
                        : 'Student/ica je ispisan/a sa odabranog studijskog programa.'
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/FilterStudents/StudyProgramWithdrawal.js